export const formatPhoneNumber = (value) => {
	let formatted = '+998'

	if (value.length > 3) formatted += ' ' + value.slice(3, 5)
	if (value.length > 5) formatted += ' ' + value.slice(5, 8)
	if (value.length > 8) formatted += ' ' + value.slice(8, 10)
	if (value.length > 10) formatted += ' ' + value.slice(10, 12)

	return formatted
}
